/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./editTemplateInformation.vue?vue&type=template&id=0fff4b6b&scoped=true"
import script from "./editTemplateInformation.vue?vue&type=script&lang=js"
export * from "./editTemplateInformation.vue?vue&type=script&lang=js"
import style0 from "./editTemplateInformation.vue?vue&type=style&index=0&id=0fff4b6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff4b6b",
  null
  
)

export default component.exports